export const itemDataSource = (props) =>{
  return [
    {
      key: '1',
      itemName: '胡彦斌',
      quantity: 32,
      address:  '西湖区湖底公园1号',
    },
    {
      key: '2',
      itemName: '胡彦祖',
      quantity: 42,
      address: '西湖区湖底公园1号',
    },
  ]
}

export const itemColumns = (props, promptMap) => [
  {
    title: props.t('tms.export.inquiryExportVO.field.itemName', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.itemName'] : '货品名称' }),
    dataIndex: 'itemName',
    key: 'itemName',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.quantity', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.quantity'] : '数量' }),
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.grossWeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.grossWeight'] : '毛重kg' }),
    dataIndex: 'grossWeight',
    key: 'grossWeight',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.netWeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.netWeight'] : '净重kg' }),
    dataIndex: 'netWeight',
    key: 'netWeight',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.volume', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.volume'] : '体积' }),
    dataIndex: 'volume',
    key: 'volume',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.itemSpecification', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.itemSpecification'] : '规格' }),
    dataIndex: 'itemSpecification',
    key: 'itemSpecification',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitLength', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitLength'] : '长mm' }),
    dataIndex: 'unitLength',
    key: 'unitLength',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitWidth', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitWidth'] : '宽mm' }),
    dataIndex: 'unitWidth',
    key: 'unitWidth',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitHeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitHeight'] : '高mm' }),
    dataIndex: 'unitHeight',
    key: 'unitHeight',
  },
];


export const packColumns = (props, promptMap) => [
  {
    title: props.t('tms.export.inquiryExportVO.field.packageNo', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.packageNo'] : '箱号' }),
    dataIndex: 'packageNo',
    key: 'packageNo',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.quantity', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.quantity'] : '数量' }),
    dataIndex: 'quantity',
    key: 'quantity',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.grossWeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.grossWeight'] : '毛重kg' }),
    dataIndex: 'grossWeight',
    key: 'grossWeight',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.netWeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.netWeight'] : '净重kg' }),
    dataIndex: 'netWeight',
    key: 'netWeight',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.volume', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.volume'] : '体积' }),
    dataIndex: 'volume',
    key: 'volume',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.packingMaterial', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.packingMaterial'] : '材质' }),
    dataIndex: 'packingMaterial',
    key: 'packingMaterial',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitLength', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitLength'] : '长mm' }),
    dataIndex: 'packingLength',
    key: 'packingLength',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitWidth', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitWidth'] : '宽mm' }),
    dataIndex: 'packingWidth',
    key: 'packingWidth',
  },
  {
    title: props.t('tms.export.inquiryExportVO.field.unitHeight', { defaultValue: promptMap ? promptMap['tms.export.inquiryExportVO.field.unitHeight'] : '高mm' }),
    dataIndex: 'packingHeight',
    key: 'packingHeight',
  },
]


// export const quoColumns = () => [
//   {
//     title: '费用名称',
//     dataIndex: 'costName',
//     key: 'costName',
//   },
//   {
//     title: '价格类型',
//     dataIndex: 'priceTypeName',
//     key: 'priceTypeName',
//   },
//   {
//     title: '币种',
//     dataIndex: 'currency',
//     key: 'currency',
//   },
//   {
//     title: '价格',
//     dataIndex: 'netWeight',
//     key: 'netWeight',
//     editable: true,
//   },
//   {
//     title: '总价',
//     dataIndex: 'volume',
//     key: 'volume',
//   },
  
// ]